<template>
<div class="main">
    <header class="">
        <div class="tit-con"> <img class="back-icon" @click="$router.go(-1)" src="@/assets/imgs/back.png" />优惠券核销记录</div>
        <el-form ref="formSearch" :inline="true" label-width="100px">
            <el-form-item label="手机号" label-width="auto;">
                <el-input v-model="keyword" />
            </el-form-item>

            <el-form-item label="核销时间" label-width="auto;">
                <el-date-picker v-model="dealTime" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="核销油站" label-width="auto;">
                <el-select v-if="gasStationList" v-model="gasStationId" placeholder="请选择">
              <el-option
                label="全部"
                value=""
              >
              </el-option>
              <el-option  v-for="item in gasStationList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
            </el-form-item>
            <el-form-item>
                <a class="imitate-el_btn" :href="exportExcel" download="1">导出</a>
            </el-form-item>
        </el-form>
    </header>

    <el-table ref="multipleTable" :data="tableData" border stripe tooltip-effect="dark" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
        <el-table-column prop="memberName" label="手机号" >
        </el-table-column>
        <el-table-column prop="amount" label="核销面值（元）" >
        </el-table-column>
        <el-table-column label="核销时间" >
            <template slot-scope="scope">{{
                    scope.row.createTime
                }}</template>
        </el-table-column>
        <el-table-column prop="gasStationName" label="核销油站" >
        </el-table-column>
        <el-table-column prop="userName" label="核销人" width="122px">
        </el-table-column>

    </el-table>
    <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalPage">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {
    rap,
    fetch
} from "@/utils/common.js";

let url = {
    // profile: "/fep/pc/user/profile",
    list: '/fep/pc/marketingUserAdmin/cancelRecord',
    exportExcel: '/fep/pc/marketingUserAdmin/exportCancelRecord',
    getGasStationList: '/fep/pc/marketingUserAdmin/gasStation'
};
export default {
    components: {},
    props: [],
    data() {
        return {
            tLoading: true,
            total: 0,
            pageNo: 1,
            pageSize: 10,
            totalPage: 0,
            tableData: [],
            multipleSelection: [],
            dealTime: "",
            keyword: undefined,
            cycle: undefined,
            gasStationList: null,
            gasStationId:undefined
        };
    },
    computed: {
        exportExcel () {
        let data = {keyword:this.keyword, gasStationId: this.gasStationId}
        if (this.dealTime) {
            data = {
            ...data,
            beginDate: this.dealTime[0],
            endDate: this.dealTime[1]
            }
        }

        let tmpArr = Object.keys(data)
        let tmpStr = '?'
        tmpArr.forEach(item => {
            let str
            str = '&' + item + '=' + data[item]
            if (data[item]) {
            tmpStr += str
            }
        })
        return url.exportExcel + tmpStr
        }
    },
    watch: {},
    created() {
        this.fetchGetGasStationList()
    },
    mounted() {
        // fetch(url.profile).then((res) => {});

        this.getList();
    },
    methods: {
        fetchGetGasStationList() {
            fetch(url.getGasStationList).then(res => {
                if (res.status === 200) {
                    this.gasStationList = res.data.list
                }
            })
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            if (row.cycle === 2) {
                return "d-sel";
            }
            return "";
        },
        clickDownload() {
            let arr = this.multipleSelection
                .map((rs) => {
                    return rs.id;
                })
                .join(",");

            let data = {
                ids: arr.join(","),
            };
            fetch(url.download, data).then(
                (res) => {
                    if (res.status === 200) {}
                },
                (res) => {
                    this.$message.error(res.message);
                }
            );
        },

        getList() {
            let beginDate = "";
            let endDate = "";
            if (this.dealTime != "" && this.dealTime != null) {
                let dateBegin = new Date(this.dealTime[0]);
                let dateEnd = new Date(this.dealTime[1]);
                beginDate = `${dateBegin.getFullYear()}-${dateBegin.getMonth() +
                    1}-${dateBegin.getDate()}`;
                endDate = `${dateEnd.getFullYear()}-${dateEnd.getMonth() +
                    1}-${dateEnd.getDate()}`;
            }
            let data = {
                beginDate,
                endDate,
                keyword: this.keyword,
                gasStationId: this.gasStationId,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            };

            fetch(url.list, data).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data.list;
                    this.totalPage = res.data.totalRow;
                }
            });
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNo = val;
            this.getList();
        },
        fetchDel(id) {
            // this.loadbtn = true
            // fetch(url.delete, {
            //     id
            // }).then(res => {
            //     if (res.status === 200) {
            //         this.$message({
            //             message: res.message,
            //             type: 'success'
            //         })
            //         this.loadbtn = false
            //         this.pClose(id)
            //         this.fetchTable()
            //     }
            // }, () => {
            //     this.loadbtn = false
            //     this.pClose(id)
            //     this.fetchTable()
            // })
        },
        pClose(id) {
            // console.log('id', id, this.$refs[`popover-${id}`].doClose)
            this.$refs[`popover-${id}`].doClose()
        },
    },
};
</script>

<style>
#app {
    overflow: auto !important;
}

.el-form-item__label {
    color: #888;
    padding-right: 8px;
    white-space: normal !important;
}

.main {
    width: 1000px;
    padding: 20px;
    margin: 30px auto 30px;
    border: 1px solid #f7f7f7;
    background: #fcfcfc;
    box-shadow: rgb(230, 240, 240, 0.6) 5px 2px 40px 5px;
}

.d-sel {
    color: rgb(223, 217, 217);
}
.tit-con {
    display: flex;
    align-items: center;
    font-weight:500;
    font-size:18px;
}
.back-icon {
    width: 25px;
    height: 25px;
    margin: 0 10px 0 0
}
</style>
